<div
  class="preloader"
  [class.preloader--ready]="isReady()"
  [class.preloader--hiding]="isHiding()"
  [style.--logo-fill-duration]="logoFillDurationMs + 'ms'"
  [style.--preloader-fade-duration]="fadeDurationMs + 'ms'"
>
  <div class="preloader__logo">
    <div class="preloader__logo-base"></div>
    <div class="preloader__logo-fill"></div>
  </div>

  @if (isReady()) {
    <button
      class="preloader__continue"
      type="button"
      (click)="continueToSite()"
    >
      CONTINUE
    </button>
  }
</div>
